import script from "./MesLivraisons.vue?vue&type=script&setup=true&lang=js"
export * from "./MesLivraisons.vue?vue&type=script&setup=true&lang=js"

import "./MesLivraisons.vue?vue&type=style&index=0&id=3d19f506&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d19f506"]])

export default __exports__